
<div class="contacts-page">
  <p-tabView styleClass="contacts-tabs">

    <!-- RICHIESTE -->
    <p-tabPanel header="Richieste">
      <div class="section-card">
        <p-table
          [value]="requests"
          styleClass="contacts-table p-datatable-sm"
          [scrollable]="true"
          responsiveLayout="scroll"
        >
          <ng-template pTemplate="caption">
            <div class="table-toolbar">
              <div class="toolbar-heading">
                <div class="toolbar-icon">
                  <i class="pi pi-inbox"></i>
                </div>
                <div>
                  <h3>Gestione richieste</h3>
                  <p>Consulta e gestisci le richieste ricevute.</p>
                </div>
              </div>

              <p-button
                label="Aggiorna"
                icon="pi pi-refresh"
                styleClass="p-button-outlined toolbar-button"
                (onClick)="loadAll()"
              ></p-button>
              <p-button
                label="Gestisci argomenti"
                icon="pi pi-list"
                styleClass="p-button-outlined toolbar-button"
                (onClick)="showTopicDialog()"
              ></p-button>
            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th class="actions-column">Azioni</th>
              <th>ID richiesta</th>
              <th>Stato</th>
              <th>Oggetto</th>
              <th>Nome e cognome</th>
              <th>Email</th>
              <th>Telefono</th>
              <th>Data apertura</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-request>
            <tr [ngClass]="{'closed': request.status === OpenCloseType.CLOSE}">
              <td>
                <div class="row-actions">
                  <p-button
                    icon="pi pi-eye"
                    styleClass="action-icon-button"
                    pTooltip="Visualizza richiesta"
                    (onClick)="showReport(request)"
                  ></p-button>

                  <p-button
                    *ngIf="request.status === OpenCloseType.OPEN"
                    icon="pi pi-ban"
                    severity="danger"
                    styleClass="action-icon-button"
                    pTooltip="Chiudi richiesta"
                    (onClick)="closeRequest(request)"
                  ></p-button>

                  <p-button
                    icon="pi pi-trash"
                    severity="danger"
                    styleClass="action-icon-button"
                    pTooltip="Elimina richiesta"
                    (onClick)="removeRequest(request)"
                  ></p-button>
                </div>
              </td>

              <td class="ticket-id">
                Ticket#{{ request.addDate | date:'yyyy' }}{{ request.addDate | date:'MM' }}{{ request.addDate | date:'d' }}-{{ request.requestId.toString().padStart(4, '0') }}
              </td>

              <td>
                <span
                  class="status-badge"
                  [ngClass]="{
                    'status-open': request.status === OpenCloseType.OPEN,
                    'status-closed': request.status === OpenCloseType.CLOSE
                  }"
                >
                  <i
                    class="pi"
                    [ngClass]="request.status === OpenCloseType.OPEN
                      ? 'pi-clock'
                      : 'pi-check-circle'"
                  ></i>
                  {{ request.status === OpenCloseType.OPEN ? 'Aperto' : 'Chiuso' }}
                </span>
              </td>

              <td>{{ request.topic.subject }}</td>
              <td class="person-name">
                {{ request.requester.name }} {{ request.requester.lastName }}
              </td>
              <td>{{ request.requester.email }}</td>
              <td>{{ request.requester.phone }}</td>
              <td>{{ request.addDate | date:'d/MM/yyyy H:mm' }}</td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8">
                <div class="empty-state">
                  <i class="pi pi-inbox"></i>
                  <strong>Nessuna richiesta presente</strong>
                  <span>Non ci sono richieste da visualizzare.</span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-tabPanel>

    <!-- REPERIBILITÀ -->
    <p-tabPanel header="Reperibilità">
      <div class="section-card availability-section">
        <div class="table-toolbar">
          <div class="toolbar-heading">
            <div class="toolbar-icon">
              <i class="pi pi-calendar"></i>
            </div>
            <div>
              <h3>Turni di reperibilità</h3>
              <p>Consulta, modifica e genera i turni settimanali.</p>
            </div>
          </div>

          <p-button
            icon="pi pi-fast-forward"
            label="Generazione automatica"
            styleClass="toolbar-button"
            (onClick)="startGeneratingSequence()"
          ></p-button>
        </div>

        <div class="availability-list">
          <div *ngIf="periods.length === 0" class="empty-state">
            <i class="pi pi-calendar-times"></i>
            <strong>Nessun turno disponibile</strong>
            <span>Non sono presenti settimane di reperibilità.</span>
          </div>

          <ng-container *ngFor="let period of periods; index as indexP">
            <div class="period-card">
              <div class="period-header">
                <div class="period-title">
                  <span class="period-number">{{ indexP + 1 }}</span>
                  <div>
                    <h3>{{ indexP + 1 }}° Settimana di reperibilità</h3>
                    <span>Gestione del periodo e delle giornate</span>
                  </div>
                </div>

                <div class="row-actions">
                  <ng-container *ngIf="editingPeriods[period.periodId!]">
                    <p-button
                      icon="pi pi-save"
                      severity="success"
                      styleClass="action-icon-button"
                      pTooltip="Salva modifiche"
                      (onClick)="modifyPeriod(period)"
                    ></p-button>

                    <p-button
                      icon="pi pi-times"
                      severity="danger"
                      styleClass="action-icon-button"
                      pTooltip="Annulla modifica"
                      (onClick)="editingPeriods[period.periodId!] = false"
                    ></p-button>
                  </ng-container>

                  <ng-container *ngIf="!editingPeriods[period.periodId!]">
                    <p-button
                      icon="pi pi-pencil"
                      styleClass="action-icon-button"
                      pTooltip="Modifica settimana"
                      (onClick)="editingPeriods[period.periodId!] = true"
                    ></p-button>

                    <p-button
                      icon="pi pi-trash"
                      severity="danger"
                      styleClass="action-icon-button"
                      pTooltip="Elimina settimana"
                      (onClick)="removePeriod(period)"
                    ></p-button>
                  </ng-container>
                </div>
              </div>

              <div class="period-dates">
                <ng-container *ngIf="editingPeriods[period.periodId!]">
                  <div class="date-field">
                    <label>Inizio</label>
                    <p-calendar
                      [dateFormat]="'DD, dd MM yy'"
                      [(ngModel)]="period.startDate"
                    ></p-calendar>
                  </div>

                  <div class="date-field">
                    <label>Fine</label>
                    <p-calendar
                      [dateFormat]="'DD, dd MM yy'"
                      [(ngModel)]="period.endDate"
                    ></p-calendar>
                  </div>
                </ng-container>

                <ng-container *ngIf="!editingPeriods[period.periodId!]">
                  <div class="date-display">
                    <i class="pi pi-calendar-plus"></i>
                    <span>
                      <small>Inizio</small>
                      {{ period.startDate | date:'cccc, dd MMMM Y' }}
                    </span>
                  </div>

                  <div class="date-display">
                    <i class="pi pi-calendar-minus"></i>
                    <span>
                      <small>Fine</small>
                      {{ period.endDate | date:'cccc, dd MMMM Y' }}
                    </span>
                  </div>
                </ng-container>
              </div>

              <div class="period-days">
                <ng-container *ngFor="let unit of period.units; index as indexU">
                  <div class="day-card" [class.day-inactive]="!unit.isActive">
                    <div class="day-heading">
                      <ng-container *ngIf="editingPeriods[period.periodId!]">
                        <p-toggleButton
                          [(ngModel)]="unit.isActive"
                          [onLabel]="(indexU + 1) + '° Giornata di reperibilità'"
                          [offLabel]="(indexU + 1) + '° Giornata di reperibilità - Servizio non attivo'"
                        ></p-toggleButton>
                      </ng-container>

                      <ng-container *ngIf="!editingPeriods[period.periodId!]">
                        <h4>{{ indexU + 1 }}° Giornata di reperibilità</h4>
                        <span
                          class="day-status"
                          [class.day-status-inactive]="!unit.isActive"
                        >
                          {{ unit.isActive ? 'Attivo' : 'Servizio non attivo' }}
                        </span>
                      </ng-container>
                    </div>

                    <ng-container *ngIf="unit.isActive">
                      <div class="day-date">
                        <ng-container *ngIf="editingPeriods[period.periodId!]">
                          <label>Data</label>
                          <p-calendar
                            [dateFormat]="'DD, dd MM yy'"
                            [(ngModel)]="unit.unitDate"
                          ></p-calendar>
                        </ng-container>

                        <ng-container *ngIf="!editingPeriods[period.periodId!]">
                          <i class="pi pi-calendar"></i>
                          {{ unit.unitDate | date:'cccc, dd MMMM Y' }}
                        </ng-container>
                      </div>

                      <div class="time-section">
                        <div class="time-heading">
                          <i class="pi pi-clock"></i>
                          <span>Orari di reperibilità</span>
                        </div>

                        <ng-container *ngIf="unit.times.length === 0">
                          <ng-container *ngIf="editingPeriods[period.periodId!]">
                            <p-button
                              icon="pi pi-plus"
                              label="Aggiungi orario"
                              styleClass="p-button-outlined compact-button"
                              (onClick)="unit.times.splice(0, 0, {
                                startTime: '08:00',
                                endTime: '20:00',
                                delegate: ''
                              })"
                            ></p-button>
                          </ng-container>

                          <span
                            *ngIf="!editingPeriods[period.periodId!]"
                            class="muted-text"
                          >
                            Nessun orario specificato
                          </span>
                        </ng-container>

                        <ng-container *ngFor="let time of unit.times; index as indexT">
                          <div class="time-card">
                            <ng-container *ngIf="editingPeriods[period.periodId!]">
                              <div class="time-delegate">
                                <label>Reperibile</label>
                                <input
                                  pInputText
                                  type="text"
                                  [(ngModel)]="time.delegate"
                                />
                              </div>
                            </ng-container>

                            <ng-container *ngIf="!editingPeriods[period.periodId!]">
                              <div class="delegate-display">
                                <i class="pi pi-user"></i>
                                <span>{{ time.delegate }}</span>
                              </div>
                            </ng-container>

                            <div class="time-range">
                              <ng-container *ngIf="editingPeriods[period.periodId!]">
                                <div class="time-field">
                                  <label>Dalle ore</label>
                                  <p-inputMask
                                    mask="99:99"
                                    [(ngModel)]="time.startTime"
                                    placeholder="Inizio"
                                  ></p-inputMask>
                                </div>

                                <div class="time-field">
                                  <label>Alle ore</label>
                                  <p-inputMask
                                    mask="99:99"
                                    [(ngModel)]="time.endTime"
                                    placeholder="Fine"
                                  ></p-inputMask>
                                </div>

                                <div class="row-actions">
                                  <p-button
                                    icon="pi pi-plus"
                                    styleClass="action-icon-button"
                                    pTooltip="Aggiungi fascia"
                                    (onClick)="unit.times.splice(indexT + 1, 0, {
                                      startTime: time.endTime,
                                      endTime: time.endTime,
                                      delegate: ''
                                    })"
                                  ></p-button>

                                  <p-button
                                    icon="pi pi-times"
                                    severity="danger"
                                    styleClass="action-icon-button"
                                    pTooltip="Rimuovi fascia"
                                    (onClick)="unit.times.splice(indexT, 1)"
                                  ></p-button>
                                </div>
                              </ng-container>

                              <ng-container *ngIf="!editingPeriods[period.periodId!]">
                                <span class="time-value">
                                  <i class="pi pi-clock"></i>
                                  {{ time.startTime }} - {{ time.endTime }}
                                </span>
                              </ng-container>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </p-tabPanel>

    <!-- CONTATTI -->
    <p-tabPanel header="Contatti">
      <div class="section-card">
        <div class="table-toolbar">
          <div class="toolbar-heading">
            <div class="toolbar-icon">
              <i class="pi pi-users"></i>
            </div>
            <div>
              <h3>Gestione contatti</h3>
              <p>Modifica i recapiti e il relativo ordine di visualizzazione.</p>
            </div>
          </div>
          <p-button
            label="Aggiungi contatto"
            icon="pi pi-plus"
            styleClass="toolbar-button add-contact-button"
            (onClick)="createNewContact()"
          ></p-button>
        </div>

        <p-table
          [value]="contacts"
          dataKey="contactId"
          editMode="row"
          [scrollable]="true"
          scrollHeight="calc(100vh - 320px)"
          responsiveLayout="scroll"
          styleClass="contacts-table p-datatable-sm"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="actions-column">Azioni</th>
              <th>Icona</th>
              <th>Contatto</th>
              <th>Descrizione</th>
              <th>Posizione</th>
            </tr>
          </ng-template>

          <ng-template
            pTemplate="body"
            let-contact
            let-editing="editing"
            let-ri="rowIndex"
          >
            <tr [pEditableRow]="contact">
              <td>
                <div class="row-actions">
                  <button
                    *ngIf="!editing"
                    pButton
                    pRipple
                    type="button"
                    pInitEditableRow
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-text"
                    (click)="onRowEditInit(contact)"
                  ></button>

                  <button
                    *ngIf="!editing"
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-text p-button-danger"
                    (click)="removeContact(contact)"
                  ></button>

                  <button
                    *ngIf="editing"
                    pButton
                    pRipple
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-check"
                    class="p-button-rounded p-button-text p-button-success"
                    (click)="onRowEditSave(contact)"
                  ></button>

                  <button
                    *ngIf="editing"
                    pButton
                    pRipple
                    type="button"
                    pCancelEditableRow
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-danger"
                    (click)="onRowEditCancel(contact, ri)"
                  ></button>
                </div>
              </td>

              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText type="text" [(ngModel)]="contact.icon" />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ contact.icon }}
                  </ng-template>
                </p-cellEditor>
              </td>

              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="contact.contact"
                      required
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    <strong>{{ contact.contact }}</strong>
                  </ng-template>
                </p-cellEditor>
              </td>

              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="contact.description"
                      required
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ contact.description }}
                  </ng-template>
                </p-cellEditor>
              </td>

              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="contact.position"
                      required
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    <span class="position-badge">{{ contact.position }}</span>
                  </ng-template>
                </p-cellEditor>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5">
                <div class="empty-state">
                  <i class="pi pi-users"></i>
                  <strong>Nessun contatto presente</strong>
                  <span>Non ci sono contatti da visualizzare.</span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-tabPanel>

  </p-tabView>
</div>

<!-- DIALOG NUOVO CONTATTO -->
<p-dialog
  header="Nuovo contatto"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [closeOnEscape]="true"
  [modal]="true"
  [visible]="creating !== undefined"
  (visibleChange)="!$event && (creating = undefined)"
  [style]="{
    width: 'calc(100vw - 32px)',
    maxWidth: '520px',
    maxHeight: 'calc(100vh - 32px)'
  }"
  styleClass="contacts-modal"
>
  <div *ngIf="creating !== undefined" class="modal-form">
    <div class="modal-description">
      <i class="pi pi-info-circle"></i>
      <span>Inserisci i dati del nuovo contatto.</span>
    </div>

    <div class="form-field">
      <label for="new-contact-icon">Icona</label>
      <input
        id="new-contact-icon"
        pInputText
        type="text"
        [(ngModel)]="creating.icon"
      />
    </div>

    <div class="form-field">
      <label for="new-contact-value">Contatto</label>
      <input
        id="new-contact-value"
        pInputText
        type="text"
        [(ngModel)]="creating.contact"
      />
    </div>

    <div class="form-field">
      <label for="new-contact-description">Descrizione</label>
      <input
        id="new-contact-description"
        pInputText
        type="text"
        [(ngModel)]="creating.description"
      />
    </div>

    <div class="form-field">
      <label for="new-contact-position">Posizione</label>
      <input
        id="new-contact-position"
        pInputText
        type="text"
        [(ngModel)]="creating.position"
      />
    </div>

    <div class="modal-actions">
      <p-button
        label="Conferma"
        icon="pi pi-check"
        (onClick)="confirmCreate()"
      ></p-button>
    </div>
  </div>
</p-dialog>

<!-- DIALOG ARGOMENTI -->
<p-dialog
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [modal]="true"
  [visible]="showTopic"
  [style]="{
    width: 'calc(100vw - 32px)',
    maxWidth: '1200px',
    maxHeight: 'calc(100vh - 32px)'
  }"
  styleClass="contacts-modal topics-modal"
>
  <ng-template pTemplate="header">
    <div class="custom-modal-header">
      <h3>Lista argomenti</h3>
      <p-button
        icon="pi pi-times"
        styleClass="p-button-text p-button-secondary"
        (onClick)="showTopic = false"
      ></p-button>
    </div>
  </ng-template>

  <div class="topics-content">
    <p-table
      [value]="topics"
      [scrollable]="true"
      responsiveLayout="scroll"
      styleClass="contacts-table p-datatable-sm"
    >
      <ng-template pTemplate="caption">
        <div class="table-toolbar">
          <div class="toolbar-heading">
            <div class="toolbar-icon">
              <i class="pi pi-list"></i>
            </div>
            <div>
              <h3>Argomenti delle richieste</h3>
              <p>Gestisci oggetti, descrizioni e destinatari.</p>
            </div>
          </div>

          <div class="toolbar-actions">
            <p-button
              label="Aggiorna"
              icon="pi pi-refresh"
              styleClass="p-button-outlined toolbar-button"
              (onClick)="loadAll()"
            ></p-button>

            <p-button
              label="Nuovo argomento"
              icon="pi pi-plus"
              styleClass="toolbar-button"
              [disabled]="currentlyEditing !== null"
              (onClick)="createNewTopic()"
            ></p-button>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th class="actions-column">Azioni</th>
          <th>Oggetto</th>
          <th>Descrizione</th>
          <th>Lista A (obbligatorio)</th>
          <th>Lista CC</th>
          <th>Lista CCN</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-topic>
        <tr *ngIf="currentlyEditing?.topicId === topic.topicId">
          <td>
            <div class="row-actions">
              <p-button
                icon="pi pi-save"
                severity="success"
                styleClass="action-icon-button"
                (onClick)="modifyTopic()"
              ></p-button>

              <p-button
                icon="pi pi-times"
                severity="danger"
                styleClass="action-icon-button"
                (onClick)="editTopic(null)"
              ></p-button>
            </div>
          </td>

          <td>
            <input pInputText type="text" [(ngModel)]="topic.subject" />
          </td>

          <td>
            <p-button
              [outlined]="true"
              (onClick)="op.toggle($event)"
            >
              {{ topic.description | slice:0:14 }}...
            </p-button>

            <p-overlayPanel #op>
              <textarea
                rows="5"
                cols="40"
                pInputTextarea
                [(ngModel)]="topic.description"
              ></textarea>
            </p-overlayPanel>
          </td>

          <td>
            <input pInputText type="text" [(ngModel)]="topic.toRecipient" />
          </td>

          <td>
            <input pInputText type="text" [(ngModel)]="topic.ccRecipient" />
          </td>

          <td>
            <input pInputText type="text" [(ngModel)]="topic.bccRecipient" />
          </td>
        </tr>

        <tr *ngIf="currentlyEditing?.topicId !== topic.topicId">
          <td>
            <div class="row-actions">
              <p-button
                icon="pi pi-pencil"
                severity="warning"
                styleClass="action-icon-button"
                (onClick)="editTopic(topic)"
              ></p-button>

              <p-button
                icon="pi pi-trash"
                severity="danger"
                styleClass="action-icon-button"
                (onClick)="removeTopic(topic)"
              ></p-button>
            </div>
          </td>

          <td>{{ topic.subject }}</td>
          <td class="description-cell">{{ topic.description }}</td>
          <td>{{ topic.toRecipient }}</td>
          <td>{{ topic.ccRecipient }}</td>
          <td>{{ topic.bccRecipient }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-dialog>

<!-- DIALOG DESCRIZIONE RICHIESTA -->
<p-dialog
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [visible]="selectedReport !== null"
  [closable]="false"
  [style]="{
    width: 'calc(100vw - 32px)',
    maxWidth: '650px',
    maxHeight: 'calc(100vh - 32px)'
  }"
  styleClass="contacts-modal report-modal"
>
  <ng-template pTemplate="header">
    <div class="custom-modal-header">
      <h3>Descrizione richiesta</h3>
      <p-button
        icon="pi pi-times"
        styleClass="p-button-text p-button-secondary"
        (onClick)="hideReport()"
      ></p-button>
    </div>
  </ng-template>

  <div class="report-content">
    <div class="report-icon">
      <i class="pi pi-file-edit"></i>
    </div>

    <div class="report-text">
      {{ selectedReport?.description }}
    </div>
  </div>
</p-dialog>

